export default __webpack_public_path__ + "static/media/Mask group.4234d3ab.png";